import moment from "moment";
import Loader from "@/components/loader/Loader.vue";

export default {
  name: "ResidentsLifestyleEventsReport",
  data() {
    return {
      search: '',
      residents: [],
      period: "month",
      startDate: moment().subtract(1, "month").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      loading: false,
      flexHeight: 250,
      picker: {
        start: false,
        end: false
      },
      periods: [
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
      ],
      headers: [
        { text: "Resident status", value: "statusDisplay" },
        { text: "Resident", value: "name" },
        { text: "Events", value: "eventsCount" },
        { text: "Events per Day", value: "eventsPerDay" },
      ],
      jsonFields: {
        "Resident status": "statusDisplay",
        "Resident": "name",
        "Events": "eventsCount",
        "Events per Day": "eventsPerDay"
      },
    }
  },
  components: {
    Loader
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility
    },
    report() {
      this.loading = false
      return this.$store.state.calenderModule.residentsLifestyleEventsReportData;
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    },
    formattedSelectedDateRange() {
      return `${moment(this.startDate).format(this.facility.dateFormat)} - ${moment(this.endDate).format(this.facility.dateFormat)}`
    }
  },
  created() {
    this.getEventsByDates()
  },
  methods: {
    routeToBack() {
      this.$router.push("/reports/lifestyleEventsReport");
    },
    handleClickResident(resident) {
      this.$router.push({ name: 'reports360view', params: { 
          backRouteName: "Lifestyle Events Report",
          id: resident.id
        }
      });
    },
    async getEventsByDates() {
      this.loading = true

      await this.$store.dispatch("getResidentsLifestyleEventsReportData", {
        startDate: moment(this.startDate).startOf('day').toDate(),
        endDate: moment(this.endDate).endOf('day').toDate()
      });

      this.residents = this.report.residents

    },
    handleChangePeriod(period) {
      this.startDate = moment()
        .subtract(1, period)
        .toISOString()
        .substring(0, 10);

      this.endDate = moment()
        .toISOString()
        .substring(0, 10);

      //reload report
      this.getEventsByDates()
    }
  }

}
